export const defaultDisplayColumnsConfig = [
  'date',
  'region',
  'cost_cash',
  'impression_total',
  'click_total',
  'cost_total',
  'cost_coupon',
  'cr',
  'cc',
  'cpm',
  'online_resources_num',
  'new_resources_num',
];
